import React, { useEffect } from 'react';
import LeafletDetail from '../LeafletDetail';
import { useNavigate } from 'react-router-dom';
function LeafletWrapper(): React.ReactElement {
  const _route = location.href.split('_route=')[1];
  const navigate = useNavigate();

  useEffect(() => {
    if (_route) {
      navigate(_route, { replace: true });
    }
  }, [_route, navigate]);

  return (
    <>
      {_route && window.location.pathname !== '/system/launcher' && (
        <LeafletDetail />
      )}
    </>
  );
}

export default LeafletWrapper;
